module.exports = __webpack_public_path__ + "img/r5.05c38a2c.jpg";